<template>
  <div v-if="!!project">
    <v-card-text
      id="card-description-text"
      flat
      v-if="showField('description') && project.description"
    >
      <label class="details-subtitle">Sobre:</label>
      <div class="description-item" v-html="project.description"></div>
    </v-card-text>

    <v-card-text
      flat
      id="card-proposedValue-text"
      v-if="showField('proposedValue') && project.proposedValue"
    >
      <label class="details-subtitle">Valor Solicitado:</label>
      <div class="proposedValue-item">
        <p>{{ project.proposedValue.toString().replace(".",",") | vueBrazil("currency") }}</p>
      </div>
    </v-card-text>

    <v-card-text
      flat
      id="card-approvedValue-text"
      v-if="showField('approvedValue') && project.approvedValue"
    >
      <label class="details-subtitle">Valor Aprovado:</label>
      <div class="approvedValue-item">
        <p>{{ project.approvedValue.toString().replace(".",",") | vueBrazil("currency") }}</p>
      </div>
    </v-card-text>

    <v-card-text
      id="card-fundingSource-text"
      flat
      v-if="
        showField('fundingSource') &&
        project.fundingSource &&
        project.fundingSource.length > 0
      "
    >
      <label class="details-subtitle">Fonte de Financiamento:</label>
      <v-row>
        <v-col
          cols="6"
          v-for="source in project.fundingSource"
          :key="source.id"
        >
          <div class="fundingSource-item">
            <v-icon>monetization_on</v-icon> {{ source.name }}
          </div>
        </v-col>

        <v-col
          cols="6"
          v-for="source in project.otherFundingSources"
          :key="'other' + source.id"
        >
          <div class="fundingSource-item">
            <v-icon>monetization_on</v-icon> {{ source.source }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card
      id="card-actingLocations-text"
      flat
      v-if="
        showField('actingLocations') &&
        project.actingLocations &&
        project.actingLocations.length > 0
      "
    >
      <v-card-text>
        <label class="details-subtitle">Locais de Atuação:</label>
        <v-row>
          <v-col
            cols="6"
            v-for="source in project.actingLocations"
            :key="source.id"
          >
            <div class="description-item">
              <v-icon>location_on</v-icon>
              <label v-if="source.city && source.city.name">
                {{ source.city.name }},
                {{ source.city.state ? source.city.state.acronym + "," : "" }}
                {{
                  source.city.state && source.city.state.country
                    ? source.city.state.country.name
                    : ""
                }}
              </label>
              <label v-else-if="source.state && source.state.acronym">
                {{ source.state.acronym }},
                {{
                  source.state && source.state.country
                    ? source.state.country.name
                    : ""
                }}
              </label>
              <label v-else-if="source.country && source.country.acronym">
                {{ source.country.name }}
              </label>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card
      id="card-areasOfInterest-text"
      flat
      v-if="
        showField('areasOfInterest') &&
        project.areasOfInterest &&
        project.areasOfInterest.length > 0
      "
    >
      <v-card-text>
        <label class="details-subtitle">Áreas de Atuação:</label>
        <ul id="icons-show">
          <li v-for="area in project.areasOfInterest" :key="area.id">
            <img class="img-des-item" v-bind:src="urlImage('area', area.id)" />
            <label class="des-item">{{ area.description }}</label>
          </li>

          <li
            v-for="area in project.otherAreasOfInterest"
            :key="'other' + area.id"
          >
            <img class="img-des-item" v-bind:src="urlImage('area', 14)" />
            <label class="des-item">{{ area.area }}</label>
          </li>
        </ul>
      </v-card-text>
    </v-card>

    <v-card
      id="card-subareasOfInterest-text"
      flat
      v-if="
        showField('subareasOfInterest') &&
        project.subareasOfInterest &&
        project.subareasOfInterest.length > 0
      "
    >
      <v-card-text>
        <label class="details-subtitle">Sub-áreas:</label>
        <ul id="icons-show">
          <li v-for="area in project.subareasOfInterest" :key="area.id">
            <img class="img-des-item" v-bind:src="urlImage('area', area.id)" />
            <label class="des-item">{{ area.description }}</label>
          </li>
        </ul>
      </v-card-text>
    </v-card>

    <v-card
      id="card-targetsAudience-text"
      flat
      v-if="
        showField('targetsAudience') &&
        project.targetsAudience &&
        project.targetsAudience.length > 0
      "
    >
      <v-card-text>
        <label class="details-subtitle">Público Alvo:</label>
        <ul id="icons-show">
          <li
            v-for="targetsAudience in project.targetsAudience"
            :key="targetsAudience.id"
          >
            <img
              class="img-des-item"
              v-bind:src="urlImage('publico', targetsAudience.id)"
            />
            <label class="des-item">{{ targetsAudience.description }}</label>
          </li>

          <li
            v-for="targetsAudience in project.otherTargetsAudience"
            :key="'other' + targetsAudience.id"
          >
            <img class="img-des-item" v-bind:src="urlImage('publico', 10)" />
            <label class="des-item">{{ targetsAudience.public }}</label>
          </li>
        </ul>
      </v-card-text>
    </v-card>

    <v-card
      id="card-ods-text"
      flat
      v-if="showField('ods') && project.ods && project.ods.length > 0"
    >
      <v-card-text>
        <label class="details-subtitle"
          >Objetivo de Desenvolvimento Sustentável:</label
        >
        <ul id="icons-show">
          <li v-for="ods in project.ods" :key="ods.id">
            <img
              class="img-des-item img-des-item-ods"
              v-bind:src="urlImage('ods', ods.id)"
            />
          </li>
        </ul>
      </v-card-text>
    </v-card>

    <v-card-text
      id="card-site-text"
      flat
      v-if="showField('sites') && project.sites"
    >
      <label class="details-subtitle">Sites:</label>
      <div v-for="site in project.sites" :key="site.id">
        <a :href="site.link" target="_blank"><p v-html="site.link"></p></a>
      </div>
    </v-card-text>

    <v-card-text
      id="card-socialNetwork-text"
      flat
      v-if="showField('socialNetwork') && project.socialNetwork"
    >
      <label class="details-subtitle">Redes Sociais:</label>
      <div v-for="socialNetwork in project.socialNetwork" :key="socialNetwork.id">
        <a :href="socialNetwork.link" target="_blank"><p v-html="socialNetwork.link"></p></a>
      </div>
    </v-card-text>

    <v-card-text
      id="card-complementaryFile-text"
      flat
      v-if="showField('complementaryFiles') && project.complementaryFiles"
    >
      <label class="details-subtitle">Arquivos complementares:</label>
      <div
        v-for="complementaryFile in project.complementaryFiles"
        :key="complementaryFile.id" class="complementaryFile-item"
      >
          <a :href="complementaryFile.link" target="_blank">
            <img :src="fileType(complementaryFile.contenttype)" id="complementaryFile-img" />
          </a>
          <div v-html="complementaryFile.name"></div>
      </div>
    </v-card-text>


    <hr />
    <v-card-text
      id="card-publicProjectAnswers-text"
      flat
      v-if="publicProjectAnswers && publicProjectAnswers.length > 0"
    >
      <label class="details-subtitle">Perguntas:</label>
      <v-row>
        <v-col cols="12" v-for="answer in joinAnswers()" :key="answer.id">
          <div class="publicProjectAnswers-subtitle title-green">
            {{ answer.question.question }}
            <span class="requiredanswer">{{
              answer.question.required ? "*" : ""
            }}</span>
          </div>
          <div class="publicProjectAnswers-item">
            <span
              v-if="
                !answer.answer &&
                !answer.questionOption &&
                (!answer.filesAnswers || answer.filesAnswers.length == 0)
              "
            >
              -- Sem resposta --
            </span>

            <span v-if="answer.answer">
              {{ fieldType(answer) }}
            </span>
            <span v-if="!answer.answer && answer.questionOption">
              {{ answer.questionOption.answer }}
            </span>
            <div v-if="answer.filesAnswers && answer.filesAnswers.length > 0">
              <div
                v-for="filesAnswer in answer.filesAnswers"
                :key="filesAnswer.id"
              >
                <span v-if="filesAnswer.file">
                  <a :href="filesAnswer.file.link" target="_blank">
                    <img :src="fileType(filesAnswer.file.contenttype)" />
                  </a>
                </span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>


<script>
import {
  mapState,
  // mapActions
} from "vuex";

export default {
  name: "PollViewProject",
  data: () => ({}),
  computed: {
    ...mapState([
      "publicPoll",
      "project",
      "pollOpportunityQuestions",
      "publicProjectAnswers",
      "publicProjectQuestionAnswers",
    ]),
  },
  methods: {
    urlImage(typeImage, id) {
      return require(`../../../pages/image/${typeImage}/${id}.png`);
    },
    showField(fieldName) {
      if (this.project === null || this.project == undefined) {
        return false;
      }
      return this.publicPoll.configuration.projectDataForDisplay[fieldName];
    },
    joinAnswers() {
      return [
        ...this.publicProjectAnswers,
        ...this.publicProjectQuestionAnswers,
      ].sort((a, b) => a.question.order - b.question.order);
    },
    fieldType(answer) {
      if (answer.question.fieldType == "Data" && answer.answer) {
        const cleanAnswer = answer.answer.replace(/"/g, "");
        const date = new Date(cleanAnswer);
        if (date && date.toString() !== "Invalid Date") {
          return date.toLocaleDateString("pt-br");
        }
      }
      return answer.answer;
    },
    filePath(file) {
      if (!file) {
        return;
      }
      const id = String(file.id).padStart(9, "0");
      const url =
        process.env.VUE_APP_SERVER_URL +
        "/uploads/system/arquivos/arquivos/" +
        id.slice(0, 3) +
        "/" +
        id.slice(3, 6) +
        "/" +
        id.slice(6, 9) +
        "/original/" +
        file.filename;
      return url;
    },
    fileType(contenttype) {
      switch (contenttype) {
        case "application/pdf":
          return "https://prosas.com.br/img/complementares/pdf.png";
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          return "https://prosas.com.br/img/complementares/docx.png";
        case "application/vnd.ms-excel":
          return "https://prosas.com.br/img/complementares/xls.png";
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          return "https://prosas.com.br/img/complementares/xls.png";
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          return "https://prosas.com.br/img/complementares/ppt.png";
        case "application/msword":
          return "https://prosas.com.br/img/complementares/doc-file-format-symbol.png";
        case "image/png":
          return "https://prosas.com.br/img/complementares/png-file-extension-interface-symbol.png";
        case "image/jpeg":
          return "https://prosas.com.br/img/complementares/jpg-image-file-format.png";
        case "jimage/jpg":
        return "https://prosas.com.br/img/complementares/jpg-image-file-format.png";
        case "text/plain":
          return "https://prosas.com.br/img/complementares/txt-text-file-extension-symbol.png";
        default:
          return "https://prosas.com.br/img/complementares/pdf.png";
      }
    },
  },
};
</script>

<style>
.v-tab {
  font-size: 12px;
}

#votingcard {
  margin: 0 0 12px;
  padding: 16px 10px;
}

#votingcard .votingcardinfo p {
  color: #20c09e;
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
  margin: 0;
}

#votingcard .votingcardinfo p.obsenvio {
  color: #323232;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  padding: 0;
}

#votingcard .votingcardinfo h3 {
  color: #415b64;
  opacity: 1;
  font-weight: 600;
  letter-spacing: -1px;
  margin: 0;
  line-height: 38px;
  font-size: 30px;
}

#votingcard .votingcardinfo h3 span {
  font-size: 18px;
}

.publicProjectAnswers-subtitle {
  font-size: 20px;
}

#votingcard #votingcardbutton {
  border-left: thin solid #ccc;
}

.terms a {
  text-transform: uppercase;
  color: white;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 1px;
  line-height: 20px;
  text-decoration: none;
}

.copy {
  text-transform: uppercase;
  color: white;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 1px;
  line-height: 20px;
}

#card-publicProjectAnswers-text span {
  color: #575757;
}

.requiredanswer {
  color: #415b64 !important;
}

.complementaryFile-item {
  display: inline-block;
  width: 100%;
  min-height: 60px;
  padding: 8px;
}

#complementaryFile-img {
  padding: 0 10px 0 0;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/poll/view/Project.vue